import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';
interface DeleteModalProp {
    resourceName: string;
    countText: string;
    visible: boolean;
    setVisible: (visible: boolean) => void;
    confirmBulkDeletion: () => Promise<void>;
    confirmDeleteAll: () => Promise<void>;
    deleteAll?: boolean;
}

const DeleteConfirmationModal = (props: DeleteModalProp): JSX.Element => {
    const dismissModal = () => props.setVisible(false);
    const onConfirm = () => {
        if (props.deleteAll) {
            props.confirmDeleteAll();
        } else {
            props.confirmBulkDeletion();
        }
        dismissModal();
    };

    const modalHeader = `${constants.DELETE_ALL_WARNING_HEADER} ${props.countText}`;
    const modalContent =`${constants.DELETE_ALL_WARNING} ${props.countText}. ${constants.BULK_DELETE_WARNING_PART_2}`;

    return (
        <Modal
            onDismiss={dismissModal}
            visible={props.visible}
            size="medium"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={dismissModal}>{constants.CANCEL_BUTTON_TEXT}</Button>
                        <Button variant="primary" onClick={onConfirm}>
                            {constants.DELETE_BUTTON_TEXT}
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={modalHeader}
        >
            {modalContent}
        </Modal>
    );   
};

export default DeleteConfirmationModal;
